import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
    token: ''
}

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        login(state, action) {
            state.token = action.payload.token;
            state.user = action.payload.user;
        },

        setUser(state, action) {
            console.log(action.payload)
            state.user = action.payload
        },

        setToken(state, action) {
            state.token = action.payload
        },

        logout(state, action) {
            state.token = "";
            state.user = {};
        },
    }

})

export default userSlice.reducer;
export const { login, logout, setUser, setToken, clearStore } = userSlice.actions;
